export default __webpack_public_path__ + "static/media/img-store-coffee-beans.1f68b8af.png";